import { Amplify, Auth } from 'aws-amplify';
import config from '../config';

Amplify.configure(config.Auth);
export async function getUser() {
  try {
    const { attributes: { email } } = await Auth.currentUserInfo();
    return email;
  } catch (err) {
    return null;
  }
}

export async function signUp(username, password) {
  try {
    // console.log(username, password);
    const { user } = await Auth.signUp({
      username,
      password,
      attributes: {
        email: username,
      },
    });
    return user;
  } catch (error) {
    console.error('error signing up:', error);
    throw error;
  }
}

export async function confirmSignUp(username, code) {
  try {
    await Auth.confirmSignUp(username, code);
    console.log('Signup confirmed');
  } catch (error) {
    console.error('error confirming signing up', error);
  }
}

export async function resendConfirmationCode(username) {
  try {
    await Auth.resendSignUp(username);
    console.log('code resent successfully');
  } catch (err) {
    console.log('error resending code: ', err);
  }
}

export async function signIn(username, password) {
  try {
    const user = await Auth.signIn(username, password);
    console.log(`Signed In User: ${JSON.stringify(user, 0, 2)}`);
    return user?.attributes?.email;
  } catch (error) {
    console.error('error signing in', error);
    throw new Error('Signin error');
  }
}

export async function signOut() {
  try {
    await Auth.signOut();
  } catch (error) {
    console.error('error signing out: ', error);
  }
}

export async function resendsignupConfirmationCode(username) {
  try {
    await Auth.resendSignUp(username);
    console.debug('code resent successfully');
  } catch (err) {
    console.error('error resending code: ', err);
  }
}

export async function forgotPassword(username) {
  // try {
  //   console.log(username);
  //   await Auth.forgotPassword(username);
  //   console.debug('code sent');
  // } catch (err) {
  //   console.error('error sending password reset code: ', err);
  // }
  Auth.forgotPassword(username)
    .then((data) => console.log(data))
    .catch((err) => console.log(err));
}

export async function confirmForgotPassword(username, code, password) {
  try {
    await Auth.forgotPasswordSubmit(username, code, password);
    console.debug('New password set');
  } catch (err) {
    console.error('error resetting password: ', err);
  }
}

export async function completenewpassword(username, code, password) {
  try {
    const user = await Auth.signIn(username, password);
    if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
      const { requiredAttributes: challengeRequiredAttributes } = user.challengeParam;
      await Auth.completeNewPassword(user, password, challengeRequiredAttributes);
    }
  } catch (err) {
    console.error('error completing new password: ', err);
  }
}
